import { render, staticRenderFns } from "./new_title.vue?vue&type=template&id=372a0af6&scoped=true&"
import script from "./new_title.vue?vue&type=script&lang=js&"
export * from "./new_title.vue?vue&type=script&lang=js&"
import style0 from "./new_title.vue?vue&type=style&index=0&id=372a0af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a0af6",
  null
  
)

export default component.exports